var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-downloader_box"},[_c('p',{staticClass:"bold_label"},[_vm._v(_vm._s(_vm.documentUrl.name))]),_c('a',{staticClass:"active-rectangle_button",attrs:{"href":_vm.documentUrl.url}},[_vm._v("ダウンロード")])])}
var staticRenderFns = []

export { render, staticRenderFns }